import script from "./asset-management-plans.vue?vue&type=script&setup=true&lang=ts"
export * from "./asset-management-plans.vue?vue&type=script&setup=true&lang=ts"

import "./asset-management-plans.vue?vue&type=style&index=0&id=a9a60910&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9a60910"]])

export default __exports__